<template>
  <v-tooltip
    attach
    bottom
    color="rgba(0, 0, 0, 0.9)"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        text
        class="d-md-flex"
        v-on="on"
        v-track="'timezone-current-time'"
        :href="routeToPref"
        target="_blank"
      >
        <span class="timezone-font">{{ currentTime }}</span>
      </v-btn>
    </template>
    {{ timezoneMsg }}
  </v-tooltip>
</template>

<script>
import moment from 'moment-timezone';
import { mapGetters } from 'vuex'
import config from "@core/config/app.config.js";
import { $users } from "@core/services";
  
export default {
  name: 'MTimezone',
  data() {
    return {
      currentTime: null,
      timezoneMsg: null,
      timezoneAbr: null,
      timezoneOffset: null
    };
  },
  computed: {
    ...mapGetters({
      preferences:"auth/preferences"
    }),
    routeToPref(){
      return `${config.MAROPOST_IDENTITY_BASE_URL}/#/preferences`;
    }
  },
  mounted(){
    this.getTimezoneMsg();
  },
  watch:{
    'preferences.time_zone'(newVal){
        if(newVal)
          this.getTimezoneMsg()
    }
  },
  created() {
    this.currentTime = moment(this.$dateViaTZ()).format("hh:mm A")+this.addTZAbr();
    this.updateTime();
    this.timer = setInterval(this.updateTime, 1000);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods:{
    getTimezoneMsg(){
      $users.getTimezones().then(response => {
        let timezoneList = response.data.data
        const selectedTimezone = timezoneList.filter(item => item.value.includes(this.preferences.time_zone));

        this.timezoneOffset = moment.tz(selectedTimezone[0].value).format('Z');

        let [ , ...nameParts ] = selectedTimezone[0].name.split(' - ');
        let name = nameParts.join(' - ');

        this.timezoneMsg = "(UTC "+this.timezoneOffset+") - "+name;

      }).catch(error => {
        console.log('error', error)
      })
    },
    updateTime() {
      this.currentTime = moment(this.$dateViaTZ()).format("hh:mm A")+this.addTZAbr();
    },
    addTZAbr(){
      this.timezoneAbr = moment.tz(this.preferences.time_zone).format('z');
      const isNumericOffset = /\+|-/.test(this.timezoneAbr);
      if(!isNumericOffset)
        return " "+this.timezoneAbr;
      else
        return "";
    }
  }
}
</script>
<style scoped>
.timezone-font{
  font-size: 14px !important;  
}
</style>